import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { LineupTable, LineupTableWrapper, Lineupwrapper, ErrorWrapper, LineupTextwrapper } from '../LineupMatchup.style';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
import CustomPlayerCell from './CustomPlayerCell';

const tbodyDataSkel = new Array(9).fill({
    name: '',
    avg: '',
    rbi: '',
    hr: '',
    sb: ''
});

export const tbodyError = [{
    name: '',
    avg: '',
    rbi: '',
    hr: '',
    sb: ''
}];

const Lineup = ({
    error,
    hasLineup,
    data
}) => {
    const customCells = useMemo(() => {
        return [
            {
                cellType: 'body',
                customCell: <CustomPlayerCell external={false} />,
                dataField: 'name'
            }
        ];
    }, [data]);

    const { teamName, players } = data || {};
    const translatedMap = {
        b: useTranslator('labelBrief_batSide', 'b'),
        avg: useTranslator('labelBrief_h_avg', 'avg'),
        hr: useTranslator('labelBrief_h_hr', 'hr'),
        rbi: useTranslator('labelBrief_rbi', 'rbi'),
        sb: useTranslator('labelBrief_h_sb', 'sb'),
        ops: useTranslator('labelBrief_ops', 'ops'),
        batter: useTranslator('box_batters', 'Batters'),
        lineup: useTranslator('lineups_subject_to_change', 'Lineups subject to change'),
        error: useTranslator('lineup_empty_message', 'Please check back later for lineup')
    };

    const theadData = useMemo(() => {
        return [
            {
                content: translatedMap.batter  + ' ' + teamName,
                dataField: 'name',
                alignment: 'left',
                fixedWidth: '145px'

            },
            {
                content: translatedMap.b,
                dataField: 'b',
                alignment: 'center',
            },
            {
                content: translatedMap.hr,
                dataField: 'hr',
                alignment: 'center',
            },
            {
                content: translatedMap.rbi,
                dataField: 'rbi',
                alignment: 'center',
            },
            {
                content: translatedMap.sb,
                dataField: 'sb',
                alignment: 'center',
            },
            {
                content: translatedMap.avg,
                dataField: 'avg',
                alignment: 'center',
            },
            {
                content: translatedMap.ops,
                dataField: 'ops',
                alignment: 'center',
            }
        ];
    }, [translatedMap]);

    const tbodyData = useMemo(() => {
        return (players === null ? [] : players)?.map((player) => {
            const { name, sb, hr, avg, rbi, ops, b, position, playerUrl, playerId } = player;

            return {
                name,
                avg,
                rbi,
                hr,
                sb,
                ops,
                b,
                position,
                playerUrl,
                playerId,
                componentName: 'Line Up'
            };
        });
    }, [players]);

    const showErrorView = error || (!hasLineup && (players === null || players?.length === 0)); // no list or list with no stats
    const showFinalView = players !== null && players?.length > 0; // list with stats
    const showLoading = !showErrorView && !showFinalView; // other situations

    return (
        <LineupTableWrapper className={ showErrorView ? 'error' : ''}>
            <LineupTable
                thead={ theadData }
                tbody={ showLoading ? tbodyDataSkel : (showErrorView ? tbodyError : tbodyData) }
                isLoading={ showLoading }
                customCells={ showFinalView && customCells }
            />

            { showFinalView && <LineupTextwrapper className={'info'}>{translatedMap.lineup}</LineupTextwrapper> }
            { showErrorView && <ErrorWrapper>{ translatedMap.error }</ErrorWrapper> }
        </LineupTableWrapper>
    );
};

Lineup.propTypes = {
    data: PropTypes.object,
    hasDataCall: PropTypes.bool,
    hasLineup: PropTypes.bool
};

export default Lineup;
